import { isSemverGreaterOrEqualThan } from "./isSemverGreaterOrEqualThan.js";
/**
 * Checks if a desktopify api version is compatible with the current version of the desktopify backend
 * @internal
 */
export function checkIfCompatibleWithBackend(apiName, introducedToBackendVersion) {
    const isCompatible = isSemverGreaterOrEqualThan(getBackendVersion(), introducedToBackendVersion);
    if (isCompatible)
        return true;
    // eslint-disable-next-line no-console
    console.warn(`[todesktop-client] ${apiName} not called. ${apiName} was introduced in ${introducedToBackendVersion}. You are running version ${getBackendVersion()}.`);
    return false;
}
const getBackendVersion = () => typeof window["todesktop"] === "object" &&
    window["todesktop"].desktopifyVersion;
export function createIsNotCompatibleHelper(namespace, defaultVersion) {
    return (methodName, version = defaultVersion) => !checkIfCompatibleWithBackend(`${namespace}:${methodName}`, version);
}
